import { FileHashPreview } from 'dy-frontend-shared/lib/data/valueObjects';

const fileHashPreview = new FileHashPreview(process.env.HASH_IMAGE_STORE_BASE_URL ?? process.env.API_BASE_URL ?? '');

export default fileHashPreview;
